/*----------------------------------------------------

	modal.js

----------------------------------------------------*/

// lack mutation observer

/* variables
---------------------------------------------------------------------------------------------------- */

const modalLinks = document.querySelectorAll('[data-modal], [data-gallery] a:not(:empty), .wp-block-image > a');
const modal = document.querySelector('#modal-box');
const modalContent = document.querySelector('#modal-box__content');

let galleryNodes = [];
let galleryCurrent = '';


/* open modal
---------------------------------------------------------------------------------------------------- */

function openModal(element = null, target = null){

  let modal_contents = getModalContents(element,target);
  let new_content = modal_contents.new_content;
  let new_class = modal_contents.new_class;

  modalContent.innerHTML = new_content;
  if(new_class){
    new_class.forEach(function(className){
      modalContent.classList.add(className);
    });
  };
  modal.showModal();
 
  bindCloseLink();

  target = (element !== null && target === null) ? (element.dataset.modal || element.getAttribute('href')) : target;

  if(target.includes('instagram')){
    loadInstagramEmbedScript();
  }

}

function getModalContents(element = null, target = null){

  let new_class = [];

  target = (element !== null && target === null) ? (element.dataset.modal || element.getAttribute('href')) : target;

  // if the target starts with '#', treat it as a CSS selector
  if(target.startsWith('#')){
    const sourceElement = document.querySelector(target);
    if(sourceElement){
      let new_content = injectClose(sourceElement.innerHTML);
    }


  // if image
  } else if(isImageUrl(target)){

    // get current elements index value
    galleryCurrent = Array.from(element.parentNode.children).indexOf(element); // requires <a> to be direct child of [data-gallery]

    lightboxHTML = '';
    lightboxHTML += '<img src="' + target + '" />';
    galleryNav = createGalleryNavigation(element);
    if(galleryNav){
      lightboxHTML += createGalleryNavigation(element);
    }

    new_content = lightboxHTML;
    new_class.push('modal--lightbox');


  // if html video
  }else if(isVideoUrl(target)){

    // get current elements index value
    galleryCurrent = Array.from(element.parentNode.children).indexOf(element);    

    const extension = target.split('.').pop().toLowerCase();

    lightboxHTML = '';
    lightboxHTML += '<video autoplay loop playsinline muted>';
    lightboxHTML += '<source src="' + target + '" type="video/' + extension + '">';
    lightboxHTML += '</video>';
    galleryNav = createGalleryNavigation(element);
    if(galleryNav){
      lightboxHTML += createGalleryNavigation(element);
    }

    new_content = lightboxHTML;
    new_class.push('modal--lightbox');


  // if instagram
  } else if(target.includes('instagram')){

    const url = target;
    const parts = url.split("/");
    const lastPart = parts[parts.length - 2];
    const embed = buildInstagramEmbed(lastPart);

    new_content = embed;
    new_class = ['modal--lightbox', 'modal--instagram'];


  // if iframe
  }else if(isVideoEmbedUrl(target)){

    embed_url = convertToEmbedUrl(target);
    new_content = '<iframe src="' + embed_url + '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
    new_class.push('modal--lightbox');


  // another page/url
  } else {

    const xhr = new XMLHttpRequest();

    // Append the 'ajax=true' query string parameter to the URL
    const ajaxUrl = target + (target.indexOf('?') === -1 ? '?' : '&') + 'ajax=true';

    // Load the content of the link's href attribute using AJAX
    xhr.open('GET', ajaxUrl);
    xhr.onload = function() {
      if (xhr.status === 200) {
        let new_content = injectClose(xhr.responseText);
      }
    };
    xhr.send();

  }


  // get caption
  if(element.dataset.modalcaption){
    new_content += '<div class="modal--lightbox__caption">' + element.dataset.modalcaption + '</div>';
  }


  return {new_content,new_class};

}


/* open modal [click event]
---------------------------------------------------------------------------------------------------- */

document.addEventListener('click', function (e){
  // Check if the clicked element matches the modal link selector
  //const modalElement = e.target.matches('[data-modal]') ? e.target : e.target.closest('[data-modal]');
  const modalElement = Array.from(modalLinks).find(link => link.contains(e.target));
  if(modalElement){
    e.preventDefault();
    openModal(modalElement);
  }
});


/* Close the modal when clicked outside of it
---------------------------------------------------------------------------------------------------- */

if(modal){
  modal.addEventListener('click', function(e){
    if (e.target === modal) {
      modal.close();
    }
  });
}


/* Remove modal content when closed
---------------------------------------------------------------------------------------------------- */

modal.addEventListener('close', function() {
  modalContent.innerHTML = '';
  modalContent.classList = [];
});


/* Close button
---------------------------------------------------------------------------------------------------- */

function bindCloseLink(){
  const closeModal = document.querySelector('#modal-box__close');
  closeModal.addEventListener('click', function() {
    modal.close();
  });
}


/* Inject close button into response code
---------------------------------------------------------------------------------------------------- */

function injectClose(source){
  if (source.includes('[close]')) {
    return source.replace('[close]', '<button id="modal-box__close"><svg viewBox="0 0 100 100" class="icon icon-cancel"><use xlink:href="#icon-cancel"></use></svg> <span class="screen-reader-text">Close</span></button>');
  } else {
    return source;
  }
}



/* Build lightbox gallery
---------------------------------------------------------------------------------------------------- */

function createGalleryNavigation(element){

  if(element.closest('[data-gallery]')){

    galleryNodes = element.closest('[data-gallery]').querySelectorAll('a:not(:empty)');
    // Filter nodes based on child elements
    galleryNodes = Array.from(galleryNodes).filter(node => {
      return node.querySelector('img') || node.querySelector('picture');
    });

    if(galleryNodes.length > 1){
      modal.removeEventListener('click', handleLightboxNav);
      modal.addEventListener('click', handleLightboxNav);

      let prev_link = '<span class="modal--lightbox__nav" data-dir="prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" baseProfile="tiny" version="1.2"><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M11.8 1 4.2 8l7.5 7"/></svg><span class="screen-reader-text">Previous</span></span>';
      let next_link = '<span class="modal--lightbox__nav" data-dir="next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" baseProfile="tiny" version="1.2"><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="m4.2 1 7.6 7-7.6 7"/></svg><span class="screen-reader-text">Next</span></span>';

      return prev_link + next_link;
    }

    return '';
  }

}

function handleLightboxNav(ev){
  if(ev.target.closest('.modal--lightbox__nav')){

    ev.stopPropagation();

    const navElement = ev.target.closest('.modal--lightbox__nav');
    const direction = navElement.dataset.dir

    let toShowIndex = galleryCurrent;
    toShowIndex += (direction === 'next') ? 1 : -1;
    toShowIndex = (toShowIndex + galleryNodes.length) % galleryNodes.length;

    const modalElement = Array.from(modalLinks).find(link => link.contains(galleryNodes[toShowIndex]));
    if(modalElement){
      openModal(modalElement);
    }else{
      modal.close();
    }

  }
}



/* Check if url is image
---------------------------------------------------------------------------------------------------- */

function isImageUrl(url){
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];
  const extension = url.split('.').pop().toLowerCase();
  return imageExtensions.includes(extension);
}


/* Check if url is video
---------------------------------------------------------------------------------------------------- */

function isVideoEmbedUrl(url) {
  const videoDomains = ['youtube.com', 'vimeo.com', 'dailymotion.com', /* Add more as needed */];
  const urlObject = new URL(url);
  const domain = urlObject.hostname;
  return videoDomains.some(videoDomain => domain.includes(videoDomain));
}

function isVideoUrl(url) {
  const supportedFormats = ['mp4', 'webm', 'ogg', 'mov']; // Add more formats if needed
  const extension = url.split('.').pop().toLowerCase();
  return supportedFormats.includes(extension);
}


/* Convert video url to something suitable to embed
---------------------------------------------------------------------------------------------------- */

function convertToEmbedUrl(originalUrl) {
  const urlObject = new URL(originalUrl);
  const hostname = urlObject.hostname;
  let embedUrl = '';

  if(hostname.includes('youtube.com')) {
    const videoId = urlObject.searchParams.get('v');
    embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : null;
  }else if(hostname.includes('vimeo.com')){
    const videoId = urlObject.pathname.split('/').pop();
    embedUrl = videoId ? `https://player.vimeo.com/video/${videoId}?autoplay=1` : null;
  }else if(hostname.includes('dailymotion.com')){
    const videoId = urlObject.pathname.split('/').pop();
    embedUrl = videoId ? `https://www.dailymotion.com/embed/video/${videoId}?autoplay=1` : null;
  }

  return embedUrl;
}


/* Load Instagram embed script
---------------------------------------------------------------------------------------------------- */

function loadInstagramEmbedScript(){
  if(!window.instagramEmbedScriptLoaded) {
    var script = document.createElement('script');
    script.async = true;
    script.src = '//www.instagram.com/embed.js';
    document.body.appendChild(script);
    window.instagramEmbedScriptLoaded = true;    
  }
  window.instgrm.Embeds.process();
}


function buildInstagramEmbed(id){

  return false;
  
}